module.exports = __webpack_public_path__ + "img/262.fa6576e2.jpg";